import * as wasm from "./progenitor_wasm_bg.wasm";
export * from "./progenitor_wasm_bg.js";
import { __wbg_set_wasm } from "./progenitor_wasm_bg.js";
__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
